import { Component, h, render } from "preact";
import { useState } from "preact/hooks";
import { decode, encode } from "msgpack-lite";
import { animationMap, AnimationRunner, loading } from "./Animation";
import { coerceStellaColor } from "../ColorCoertion";

let application: App;

window.addEventListener("load", () => {
    render(<App ref={(v: App) => application = v}/>, document.getElementById("app")!);
});

let websocket: WebSocket | undefined;

function connectToStellaBIO(ip: string) {
    websocket = new WebSocket(`wss://${ip.replace(/\./mg, "-")}.wildcard.direct.egzotech.com:443`);
    websocket.binaryType = "arraybuffer";

    application.setState({
        connectionState: "connecting"
    });

    websocket.onclose = () => {
        application.setState({
            connectionState: "disconnected"
        });
    }

    websocket.onerror = () => {
        application.setState({
            connectionState: "error"
        });
    }

    websocket.onopen = () => {
        application.setState({
            connectionState: "connected"
        });
    }

    let i = 0;

    websocket.onmessage = (e) => {
        //console.log(i);
        i++;
        //console.log(decode(e.data));
    }
}

export function sendLedsToStellaBIO(arr: ArrayLike<number>) {
    if (!websocket) {
        return false;
    }

    if (arr.length !== 12) {
        return false;
    }

    const copy = Array.from(arr);

    for (let i = 0; i < copy.length; i++) {
        let r = (arr[i] >> 16) & 0xff;
        let g = (arr[i] >> 8) & 0xff;
        let b = (arr[i]) & 0xff;

        r = Math.floor(r / 4);
        g = Math.floor(g / 4);
        b = Math.floor(b / 4);

        copy[i] = (r << 16) | (g << 8) | b;
    }

    const a = encode({ led: new Uint32Array(copy) });
    websocket.send(a);
    return true;
}

function multiplyColor(color: number, scalar: number) {
    let r = (color >> 16) & 0xff;
    let g = (color >> 8) & 0xff;
    let b = (color) & 0xff;

    r = Math.max(0, Math.min(255, Math.round(r * scalar)));
    g = Math.max(0, Math.min(255, Math.round(g * scalar)));
    b = Math.max(0, Math.min(255, Math.round(b * scalar)));

    return (r << 16) | (g << 8) | b;
}

function coerceColor(color: string) {
    if (color.startsWith("#")) {
        return color;
    }

    return "#" + color;
}

class App extends Component {
    readonly animationRunner = new AnimationRunner();

    state = {
        ip: "192.168.1.202",
        connectionState: "disconnected",
        color1: "#000000",
        color2: "#000000",
        color3: "#000000",
        stellaColor: "#000000",
        time: "1000",
        sendState: "none",
        isAnimating: false
    }

    render() {

        // = new WebSocket(`wss://${(parameters.ip ?? "192.168.1.221").replace(/\./mg, "-")}.wildcard.direct.egzotech.com:${parameters.port ?? "8443"}`);
        // this.websocket.binaryType = "arraybuffer";
        return <div style="max-width: 1000px; margin: auto; margin-top: 20px;">
            <div>
                <div class="paper" style="padding: 10px; display: flex; align-items: center;">
                    <span>StellaBIO ip address:</span>
                    <input type="text" value={this.state.ip} style="margin-left: 10px" onChange={(e) => this.setState({ ip: e.currentTarget.value})}></input>
                    <button type="button" style="margin-left: 10px" onClick={() => connectToStellaBIO(this.state.ip)}>Connect</button>
                    {this.state.connectionState === "disconnected" ? null :
                        this.state.connectionState === "connected" ?
                        <span class="alert success" style="margin-left: 10px">Connected</span> :
                        this.state.connectionState === "error" ?
                        <span class="alert error" style="margin-left: 10px">Error occured</span> :
                        this.state.connectionState === "connecting" ?
                        <span class="alert info" style="margin-left: 10px">Connecting...</span> :
                        null
                     }
                </div>
                {this.state.connectionState === "connected" || true ?
                    <div>
                        <div class="paper" style="padding: 10px; margin-top: 10px;">
                            <div style="display: flex; align-items: center">
                                <span>LED Color 1: </span>
                                <div><input type="text" style="margin-left: 10px" value={this.state.color1} onChange={(e) => this.setState({ color1: coerceColor(e.currentTarget.value) })}></input></div>
                                <div><input type="color" style="margin-left: 10px" value={this.state.color1} onInput={(e) => this.setState({ color1: e.currentTarget.value })} onChange={(e) => this.setState({ color1: e.currentTarget.value })}></input></div>
                                <label style="margin-left: 10px; display: flex; align-items: center">Override <input type="checkbox" style="margin-left: 10px" checked={this.animationRunner.overrideColors[0]} onChange={(e) => { this.animationRunner.overrideColors[0] = e.currentTarget.checked; this.forceUpdate(); }}></input></label>
                            </div>
                            <div style="display: flex; align-items: center; margin-top: 5px">
                                <span>LED Color 2: </span>
                                <div><input type="text" style="margin-left: 10px" value={this.state.color2} onChange={(e) => this.setState({ color2: coerceColor(e.currentTarget.value) })}></input></div>
                                <div><input type="color" style="margin-left: 10px" value={this.state.color2} onInput={(e) => this.setState({ color2: e.currentTarget.value })} onChange={(e) => this.setState({ color2: e.currentTarget.value })}></input></div>
                                <label style="margin-left: 10px; display: flex; align-items: center">Override <input type="checkbox" style="margin-left: 10px" checked={this.animationRunner.overrideColors[1]} onChange={(e) => { this.animationRunner.overrideColors[1] = e.currentTarget.checked; this.forceUpdate(); }}></input></label>
                            </div>
                            <div style="display: flex; align-items: center; margin-top: 5px">
                                <span>LED Color 3: </span>
                                <div><input type="text" style="margin-left: 10px" value={this.state.color3} onChange={(e) => this.setState({ color3: coerceColor(e.currentTarget.value) })}></input></div>
                                <div><input type="color" style="margin-left: 10px" value={this.state.color3} onInput={(e) => this.setState({ color3: e.currentTarget.value })} onChange={(e) => this.setState({ color3: e.currentTarget.value })}></input></div>
                                <label style="margin-left: 10px; display: flex; align-items: center">Override <input type="checkbox" style="margin-left: 10px" checked={this.animationRunner.overrideColors[2]} onChange={(e) => { this.animationRunner.overrideColors[2] = e.currentTarget.checked; this.forceUpdate(); }}></input></label>
                            </div>
                            <div style="display: flex; align-items: center; margin-top: 5px">
                                <span>Time: </span>
                                <div><input type="text" style="margin-left: 10px" value={this.state.time} onChange={(e) => this.setState({ time: e.currentTarget.value })}></input> ms</div>
                                <label style="margin-left: 10px; display: flex; align-items: center">Override <input type="checkbox" style="margin-left: 10px" checked={this.animationRunner.overrideTime} onChange={(e) => { this.animationRunner.overrideTime = e.currentTarget.checked; this.forceUpdate(); }}></input></label>
                            </div>
                        </div>
                        <div class="paper" style="padding: 10px; margin-top: 10px;">
                            <div style="font-weight: bold; font-size: 16px;">Stella color fix</div>
                            <div style="display: flex; align-items: center; margin-top: 10px">
                                <span>Choose color: </span>
                                <div><input type="text" style="margin-left: 10px" value={this.state.stellaColor} onChange={(e) => this.setState({ stellaColor: coerceColor(e.currentTarget.value) })}></input></div>
                                <div><input type="color" style="margin-left: 10px" value={this.state.stellaColor} onInput={(e) => this.setState({ stellaColor: e.currentTarget.value })} onChange={(e) => this.setState({ stellaColor: e.currentTarget.value })}></input></div>
                                <div style="margin-left: 20px;">Output</div>
                                <div style={{ width: "100px", marginLeft: "10px", height: "100px", backgroundColor: "#" + coerceStellaColor(parseInt(this.state.stellaColor.substr(1), 16)) }}/>
                            </div>
                        </div>
                        <div class="paper" style="padding: 10px; margin-top: 10px;">
                            <div style="display: flex; align-items: center">
                                <button type="button" onClick={() => {
                                    console.log(this.state.color1);
                                    const num = parseInt(this.state.color1.substr(1), 16);

                                    if (!sendLedsToStellaBIO([
                                        num, num, num, num,
                                        num, num, num, num,
                                        num, num, num, num,
                                    ])) {
                                        this.setState({ sendState: "error" });
                                    }
                                    else {
                                        this.setState({ sendState: "none" });
                                    }
                                }}>Set Color 1</button>
                                <button style="margin-left: 10px" type="button" onClick={() => {
                                    console.log(this.state.color1);
                                    const num = parseInt(this.state.color2.substr(1), 16);

                                    if (!sendLedsToStellaBIO([
                                        num, num, num, num,
                                        num, num, num, num,
                                        num, num, num, num,
                                    ])) {
                                        this.setState({ sendState: "error" });
                                    }
                                    else {
                                        this.setState({ sendState: "none" });
                                    }
                                }}>Set Color 2</button>
                                <button style="margin-left: 10px" type="button" onClick={() => {
                                    console.log(this.state.color1);
                                    const num = parseInt(this.state.color3.substr(1), 16);

                                    if (!sendLedsToStellaBIO([
                                        num, num, num, num,
                                        num, num, num, num,
                                        num, num, num, num,
                                    ])) {
                                        this.setState({ sendState: "error" });
                                    }
                                    else {
                                        this.setState({ sendState: "none" });
                                    }
                                }}>Set Color 3</button>
                            </div>
                            <div style="display: flex; align-items: center; margin-top: 10px">
                                <select value={this.animationRunner.animation} onChange={(e) => {
                                    this.animationRunner.animation = e.currentTarget.value;
                                }}>
                                    {Object.keys(animationMap).map((prop) => <option value={prop}>{prop}</option>)}
                                </select>
                                <button type="button" class={this.state.isAnimating ? "disabled": ""} style="margin-left: 10px" onClick={() => {
                                    this.setState({ sendState: "none" });

                                    this.animationRunner.start();
                                    let lastTime = performance.now();

                                    const a = () => {
                                        this.animationRunner.colors[0] = this.state.color1;
                                        this.animationRunner.colors[1] = this.state.color2;
                                        this.animationRunner.colors[2] = this.state.color3;
                                        this.animationRunner.animationTime = parseInt(this.state.time);

                                        try {
                                            this.animationRunner.run(performance.now() - lastTime);
                                        }
                                        catch(ex) {
                                            this.setState({ sendState: "error" });
                                            return;
                                        }

                                        lastTime = performance.now();

                                        if (this.state.isAnimating) {
                                            setTimeout(a, 25);
                                        }
                                    };

                                    this.setState({ isAnimating: true });
                                    setTimeout(a, 25);
                                }}>Animate</button>
                                <button type="button" style="margin-left: 10px" onClick={() => {
                                    this.setState({ isAnimating: false });
                                }}>Stop animation</button>
                                <button type="button" style="margin-left: 10px" onClick={() => {
                                    this.animationRunner.start();
                                }}>Reset state</button>
                                <button type="button" style="margin-left: 10px" onClick={() => {
                                    this.animationRunner.next();
                                }}>Increment state</button>
                                {this.state.sendState === "error" ? <span class="alert error">Error</span> : null}
                            </div>
                        </div>
                    </div>
                : null}
            </div>
        </div>;
    }
}
